// extracted by mini-css-extract-plugin
module.exports = {"saleTag":"SaleTag_saleTag__GIvwi"};